import React from "react";
import { Card, Button, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BASE_URL } from "../services/path";
import moment from "moment";

const EventCard = ({ title, events }) => {
  return (
    <div className="event-card-container">
      <div className="mb-sm-4 mb-3 common-heading">
        <h2>{title}</h2>
      </div>
      {events &&
        events?.length > 0 &&
        events.map((item) => {
          return (
            <Card className="event-card mb-3">
              <Row>
                {/* Left Section: Image */}
                <Col md={3}>
                  <figure>
                    <Image
                      src={`${BASE_URL}/uploads/${item.headerImage}`} // Replace with your image URL
                      alt="Event"
                      className="event-image"
                      fluid
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src =
                          "https://t4.ftcdn.net/jpg/07/95/29/45/240_F_795294584_LZ4NllndEBSy8vbi37sYngiLIaPdUvtQ.jpg";
                      }}
                    />
                  </figure>
                </Col>

                {/* Right Section: Content */}
                <Col md={9}>
                  <Card.Body>
                    <div className="event-info">
                      <div className="event-left-card">
                        <div className="event-date-time">
                          <span className="event-date">
                            <i className="bi bi-calendar3"></i>{" "}
                            {moment(item.date).format("DD MMM YYYY")}
                          </span>
                          <span className="event-time">
                            <i className="bi bi-clock"></i> {item.time}
                          </span>
                        </div>

                        <h5 className="event-title multi-truncate">
                          {item.name}
                        </h5>

                        <p className="event-location multi-truncate">
                          <i className="bi bi-geo-alt"></i>
                          {item.address}
                        </p>
                      </div>

                      <div className="event-actions">
                        <Link
                          to={`/events/${item._id}`}
                          className="themeht-btn btn"
                        >
                          <span>View More</span>
                          <i className="bi bi-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </Card.Body>
                </Col>
              </Row>
            </Card>
          );
        })}
    </div>
  );
};

export default EventCard;
